module.exports = __webpack_public_path__ + "pc/img/rec_11.5277d59c.svg";